import { render, staticRenderFns } from "./LoyaltyCard.vue?vue&type=template&id=0f587150&scoped=true"
import script from "./LoyaltyCard.vue?vue&type=script&lang=ts"
export * from "./LoyaltyCard.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyCard.vue?vue&type=style&index=0&id=0f587150&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f587150",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f587150')) {
      api.createRecord('0f587150', component.options)
    } else {
      api.reload('0f587150', component.options)
    }
    module.hot.accept("./LoyaltyCard.vue?vue&type=template&id=0f587150&scoped=true", function () {
      api.rerender('0f587150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/LoyaltyCard.vue"
export default component.exports